// Keep the Work list tables' SeeMe behaviour alive across swaps.
//
// `tables.js` initialises `.js-data-table` once, on DOMContentLoaded — which is
// what binds the group headers' collapse. This table is replaced on every
// filter change and by the websocket list refresh, so the fresh markup arrives
// with nothing bound. Re-run the shared initialiser over the new content.
//
// Scoped to the Work list regions on purpose: other pages have swapped tables that
// have never been initialised after a swap either, and quietly turning their
// behaviour on is not this file's call.
(function () {
    function init(root, alreadyInitialized) {
        if (!window.initDataTable || !root || !root.querySelectorAll) return;
        var containers = [];
        if (root.matches && root.matches('.js-data-table')) containers.push(root);
        root.querySelectorAll('.js-data-table').forEach(function (el) { containers.push(el); });
        containers.forEach(function (container) {
            if (!container.closest('[data-work-task-list-region], [data-work-plan-list]')) return;
            // initDataTable adds listeners, so it must run once per element.
            if (container.dataset.dtInit) return;
            container.dataset.dtInit = '1';
            if (!alreadyInitialized) window.initDataTable(container);
        });
    }

    document.body.addEventListener('htmx:load', function (e) { init(e.target); });
    // SeeMe's earlier DOMContentLoaded handler has already initialized these.
    document.addEventListener('DOMContentLoaded', function () { init(document.body, true); });
})();
